import React, { useRef, useEffect } from 'react';
import { cloneDeep } from 'lodash-es';
import './style.less';
import { Spin } from 'antd';

const TokenInput = ({ tokenInputs, setTokenInputs, isLoading, tokenRegex }) => {
  const sectionRef = useRef();

  useEffect(() => {
    sectionRef.current.children[0].focus();
  }, [sectionRef]);

  function handleInputChange(value, index) {
    const newArray = cloneDeep(tokenInputs);
    newArray[index] = value;
    setTokenInputs(newArray);
    if (value) {
      const nextIndex = index >= tokenInputs.length - 1 ? index : index + 1;
      sectionRef.current.children[nextIndex].focus();
    }
  }

  function handleKeyPress(e, index) {
    if (!tokenInputs[index] && (e.key === 'Delete' || e.key === 'Backspace')) {
      const prevIndex = index > 0 ? index - 1 : index;
      sectionRef.current.children[prevIndex].focus();
      e.preventDefault();
    }
  }

  function handlePaste(e) {
    e.preventDefault();
    const value = e.clipboardData.getData('Text');
    if (tokenRegex.test(value) && tokenInputs.join('') === '') {
      setTokenInputs(value.split(''));
    }
  }

  return (
    <div ref={sectionRef} className="otp-input-section">
      {tokenInputs.map((ip, index) => (
        <input
          key={index}
          className="otp-input-box"
          inputMode="numeric"
          maxLength={1}
          value={ip}
          onChange={(e) => handleInputChange(e.target.value, index)}
          onKeyDown={(e) => {
            handleKeyPress(e, index);
          }}
          onPaste={handlePaste}
          disabled={isLoading}
        />
      ))}
      {isLoading && <Spin />}
    </div>
  );
};

export default TokenInput;
